module.exports = __webpack_public_path__ + "static/media/U1-T2-4-1a.cadd4280.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-4-1a.svg
// module id = 586
// module chunks = 0